export function isDeepEqualSimple (a, b) {
  if (a === b) {
    return true;
  }

  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }

  for (const key in a) {
    if (typeof a[key] === "object" && typeof b[key] === "object") {
      if (!isDeepEqualSimple(a[key], b[key])) {
        return false;
      }
    }

    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}

export function values (obj) {
  if (Object.values) {
    return Object.values(obj);
  } else {
    return Object.keys(obj).map((key) => obj[key]);
  }
}
